var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapActions } from 'vuex';
import { Const } from './provider/candle-history/lib/const.cls';
import * as Types from '../../types';
import { fxView } from './lib/fxView.cls';
import * as fxViewStoreExtensions from './provider/candle-history';
var state = __assign({}, fxViewStoreExtensions.stateExt);
var actions = __assign({}, fxViewStoreExtensions.actionsExt);
var mutations = __assign({}, fxViewStoreExtensions.mutationsExt);
var getters = __assign({}, fxViewStoreExtensions.gettersExt);
var fireabase_messaging;
var fireabase_SW = "";
var fxViewStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
var _store;
var intervalValue = null;
export var fxViewMixins = {
    created: function () {
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[fxView.STORE_MODULE_NAME])) {
            try {
                this.$store.registerModule(fxView.STORE_MODULE_NAME, fxViewStore);
            }
            catch (error) { }
        }
        // this.intializeFirebase()
    },
    methods: __assign({}, mapActions({
        //static variable fetch from database
        _runGetCountriesList: Const.RUN_GET_COUNTRIES_LIST,
        _runGetCitiesList: Const.RUN_GET_CITIES_LIST,
        //dashboard
        _runApiDashboardData: Const.RUN_API_DASHBOARD_DATA,
        _runGetDashboardOtherData: Const.RUN_GET_DASHBOARD_OTHER_DATA,
        _runGetTotalClient: Const.RUN_GET_TOTAL_CLIENT,
        _runGetTotalSubIb: Const.RUN_GET_TOTAL_SUBIB,
        _runGetdashboardChartData: Const.RUN_GET_DASHBOARD_CHART_DATA,
        // user sub ib list
        _runUserSubIbList: Const.RUN_GET_USER_SUBIB_LIST,
        //admin
        _runGetIBList: Const.RUN_GET_IB_LIST,
        _runGetIBDetail: Const.RUN_GET_IB_DETAIL,
        //client
        _runGetUserList: Const.RUN_GET_USER_LIST,
        _runGetUserView: Const.RUN_GET_USER_VIEW,
        _runUserCount: Const.RUN_USER_COUNT,
        //deposit
        _runGetDepositList: Const.RUN_GET_DEPOSIT_LIST,
        _runGetDepositView: Const.RUN_GET_DEPOSIT_VIEW,
        //bonus
        _runGetBonusList: Const.RUN_GET_BONUS_LIST,
        _runGetBonusView: Const.RUN_GET_BONUS_VIEW,
        _runGetUserProfile: Const.RUN_GET_USER_PROFILE,
        _runGetUserRegisterationStepData: Const.RUN_GET_USER_REGISTERATION_STEP_DATA,
        _runWithdrawalRequestOtp: Const.RUN_COMMISSION_REQUEST,
        _runGetAffiliateEarning: Const.RUN_GET_AFFILIATE_EARNINGS,
        //withdrawal
        _runGetWithdrawalCommList: Const.RUN_GET_WITHDRAWAL_COMMISSION_LIST,
        _runGetWithdrawalList: Const.RUN_GET_WITHDRAWAL_LIST,
        _runGetWithdrawalView: Const.RUN_GET_WITHDRAWAL_VIEW,
        //_runWithdrawalMethods			            	:   			Const.RUN_WITHDRAWAL_METHODS,
        _runGetAccountDetails: Const.RUN_GET_ACCOUNT_DETAIL,
        //_runWithdrawalRequestOtp						:   			Const.RUN_WITHDRAWAL_REQUEST_OTP,
        _runWithdrawalCheckOtp: Const.RUN_WITHDRAWAL_CHECK_OTP,
        _runResendEmailLink: Const.RUN_RESEND_EMAIL_LINK,
        _runGetWithdrawalMethods: Const.RUN_GET_WITHDRAWAL_METHODS,
        _runGetWithdrawalDesc: Const.RUN_GET_WITHDRAWAL_DESC,
        //trading
        _runGetTradingList: Const.RUN_GET_TRADING_LIST,
        _runGetIBTradingList: Const.RUN_GET_IB_TRADING_LIST,
        _runGetTradingView: Const.RUN_GET_TRADING_VIEW,
        _runGetTradingAccountDetail: Const.RUN_GET_TRADING_ACCOUNT_DETAIL,
        //======================support=======================================================
        _runGetTicketList: Const.RUN_GET_TICKET_LIST,
        _runGetTicketDetail: Const.RUN_GET_TICKET_DETAIL,
        _runTicketRequestOtp: Const.RUN_TICKET_REQUEST_OTP,
        _runTicketCheckOtp: Const.RUN_TICKET_CHECK_OTP,
        _runTicketReply: Const.RUN_TICKET_REPLY,
        _runGetTicketReasonList: Const.RUN_GET_TICKET_REASON_LIST,
        _runTicketResendOtp: Const.RUN_TICKET_RESEND_OTP,
        _runGetTradingAccountList: Const.RUN_GET_TRADING_ACCOUNT_LIST,
        _runGetUserCommission: Const.RUN_GET_USER_COMMISSION,
        //======================get withdarwal method list======================
        _runGetWithdrawalMethodlist: Const.RUN_WITHDRAWAL_METHOD_LIST,
    }), { handleValidationErrorAdvanced: function (getErrors) {
            try {
                var firstField = Object.keys(getErrors.collect())[0];
                this.$refs[firstField + "Input"].focus();
                return this.$refs[firstField + "Input"].scrollIntoView();
            }
            catch (e) { }
        },
        redirect: function () {
            this.$router.replace({ name: "fxView.support", params: { tabName: 'openRequest', page: 'view_dash' } });
        },
        setData: function (getTitleName) {
            this.$parent.pageTitle = getTitleName;
            this.$parent.message = '';
            this.$parent.message_type = '';
        },
        computedCommonFunc: function (getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        },
        stepPageOpenFunc: function (getStep) {
            var step = '/step' + (parseInt(this.get_user.step) + 1);
            return step;
        },
        clearMessage: function () {
            this.response_msg = '';
            this.msg_type = '';
        } }),
    computed: {
        getUserProfile: function () { return this.computedCommonFunc(Const.GET_USER_PROFILE); },
        dashboardData: function () { return this.computedCommonFunc(Const.GET_DASHBOARD_DATA); },
        countriesList: function () { return this.computedCommonFunc(Const.GET_COUNTRIES_LIST); },
        citiesList: function () { return this.computedCommonFunc(Const.GET_CITIES_LIST); },
        dashboardChartData: function () { return this.computedCommonFunc(Const.GET_DASHBOARD_CHART_DATA); },
        //ib
        adminList: function () { return this.computedCommonFunc(Const.GET_IB_LIST); },
        adminDetail: function () { return this.computedCommonFunc(Const.GET_IB_DETAIL); },
        accountDetails: function () { return this.computedCommonFunc(Const.GET_TRADING_ACCOUNT_DETAIL); },
        //client
        get_user: function () { return this.computedCommonFunc(Types.GET_USER); },
        countriesJsonForIb: function () { return this.computedCommonFunc(Types.GET_COUNTRIES_FOR_IB); },
        userList: function () { return this.computedCommonFunc(Const.GET_USER_LIST); },
        userView: function () { return this.computedCommonFunc(Const.GET_USER_VIEW); },
        userCount: function () { return this.computedCommonFunc(Const.GET_USER_COUNT); },
        //deposit
        depositList: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_LIST); },
        depositView: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_VIEW); },
        //bonus
        bonusList: function () { return this.computedCommonFunc(Const.GET_BONUS_LIST); },
        bonusView: function () { return this.computedCommonFunc(Const.GET_BONUS_VIEW); },
        //withdrawal
        withdrawalList: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_LIST); },
        withdrawalCommList: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_COMMISSION_LIST); },
        affiliateCommList: function () { return this.computedCommonFunc(Const.GET_AFFILIATE_EARNINGS); },
        withdrawalView: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_VIEW); },
        withdrawalMethodResponse: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD_RESPONSE); },
        withdrawalMethodResponseDep: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP); },
        withdrawalMethod: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD); },
        //withdrawal method list
        withdrawalSkrillList: function () { return this.computedCommonFunc(Const.GET_SKRILL_ID); },
        withdrawalNetellerList: function () { return this.computedCommonFunc(Const.GET_NETELLER_ID); },
        withdrawalCryptoList: function () { return this.computedCommonFunc(Const.GET_CRYPTO_ID_LIST); },
        //trading
        tradingList: function () { return this.computedCommonFunc(Const.GET_TRADING_LIST); },
        ibtradingList: function () { return this.computedCommonFunc(Const.GET_IB_TRADING_LIST); },
        tradingView: function () { return this.computedCommonFunc(Const.GET_TRADING_VIEW); },
        //support
        ticketData: function () { return this.computedCommonFunc(Const.GET_TICKET_DATA); },
        ticketList: function () { return this.computedCommonFunc(Const.GET_TICKET_LIST); },
        ticketView: function () { return this.computedCommonFunc(Const.GET_TICKET_VIEW); },
        ticketReasonList: function () { return this.computedCommonFunc(Const.GET_TICKET_REASON_LIST); },
        //static
        currency: function () { return this.computedCommonFunc(Const.GET_CURRENCY); },
        demoLive: function () { return this.computedCommonFunc(Const.GET_DEMO_LIVE); },
        proUsers: function () { return this.computedCommonFunc(Const.GET_PRO_USERS); },
        withdrawalType: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_TYPE); },
        withdrawalMethods: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHODS); },
        withdrawalStatus: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_STATUS); },
        depositMethod: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_METHOD); },
        depositStatus: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_STATUS); },
        stepsText: function () { return this.computedCommonFunc(Const.GET_STEP); },
        empStatus: function () { return this.computedCommonFunc(Const.GET_EMP_STATUS); },
        occupation: function () { return this.computedCommonFunc(Const.GET_OCCUPATION); },
        estYearlyIncome: function () { return this.computedCommonFunc(Const.GET_EST_YEARLY_INCOME); },
        estNetWorth: function () { return this.computedCommonFunc(Const.GET_EST_NET_WORTH); },
        antAccountTurnover: function () { return this.computedCommonFunc(Const.GET_ACCOUNT_TURNOVER); },
        genderList: function () { return this.computedCommonFunc(Const.GET_GENDER_LIST); },
        ticketDocsLink: function () { return this.computedCommonFunc(Const.GET_TICKET_DOCS_LINK); },
        departmentList: function () { return this.computedCommonFunc(Const.GET_DEPARMENT_LIST); },
        bonusType: function () { return this.computedCommonFunc(Const.GET_BONUS_TYPE); },
        bonusStatus: function () { return this.computedCommonFunc(Const.GET_BONUS_STATUS); },
        dashboardLink1: function () { return this.computedCommonFunc(Const.GET_DASHBOARD_LINK1); },
        dashboardLink2: function () { return this.computedCommonFunc(Const.GET_DASHBOARD_LINK2); },
        // user sub ib list
        subIbList: function () { return this.computedCommonFunc(Const.GET_USER_SUBIB_LIST); },
        tradingAccountList: function () { return this.computedCommonFunc(Const.GET_TRADING_ACCOUNT_LIST); },
        userCommission: function () { return this.computedCommonFunc(Const.GET_USER_COMMISSION); },
    }
};
export default fxViewMixins;



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/index.ts
// module id = null
// module chunks = 